<template>
  <div class="main">
    <h2>{{title}}</h2>
    <div class="ArFunction">
      <el-image
        v-for="item in img"
        :key="item"
        class="img"
        :src="item"
        fit="fill"
      >
      </el-image>
    </div>
  </div>
</template>

<script>
import page1 from "@/assets/imgToys/page1.jpg";
import page2 from "@/assets/imgToys/page2.jpg";
import page3 from "@/assets/imgToys/page3.jpg";
export default {
  props:["title"],
  data() {
    return {
      img: [page1, page2, page3],
    };
  },
};
</script>

<style scoped>
.main {
  padding: 0 0 30px 0;
  margin-top: 10px;
  /* background-color: #eee; */
}
.main h2 {
  padding: 30px;
  background-color: #bfbfbf;
}
.ArFunction {
  /* width: 50%; */
  padding: 0px 30px;
  /* height: 600px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.img {
  width: 32%;
  /* height: 49%; */
}
/*手机*/
@media screen and (max-width: 767px) {
  .img {
    width: 100%;
    height:450px;
    margin-bottom: 10px;
  }
  .ArFunction {
      /* padding: 0px; */
      padding: 0 40px;
  }
}
/*平板*/
@media screen and (min-width: 768px) and (max-width: 992px) {
  /* .img {
    width: 100%;
    height:500px;
    margin-bottom: 10px;
  }
  .ArFunction {
      padding: 0 30px;
  } */
}
</style>    


// WEBPACK FOOTER //
// src/common/ArFunction.vue